$(document).ready(function () {
	// Contact page accordion
    if ($('.contact-accordion').length > 0) {
    	$('.contact-type.open .contact-details').show();
    	$('.contact-title').click(function() {
    		$(this).next().slideToggle();
    		$(this).parent().toggleClass('open');
    		if ($(this).parent().hasClass('open')) {
    			$(this).find('span.arrow').addClass('open');
    		} else {
    			$(this).find('span.arrow').removeClass('open');
    		}
    	});
    }
});